/* =========================================================
	CookieConsent v3
	https://cookieconsent.orestbida.com

	Combined with Gist by Mark Croxton for
	GTM & Google Consent Mode v2
	https://gist.github.com/croxton/060899d07a2a9491ab0c20da74fdb700
========================================================= */

// import 'https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@3.0.1/dist/cookieconsent.umd.js';
import * as CookieConsent from "vanilla-cookieconsent";

class CookieConsentInit {

	constructor() {
		CookieConsent.run({
			// Update Google Consent Mode v2
			onConsent: () => {
				updateGtagConsent();
			},

			onChange: ({ changedCategories }) => {
				updateGtagConsent();
		  },

			categories: {
				necessary: {
					enabled: true,  // this category is enabled by default
					readOnly: true  // this category cannot be disabled
				},
				preferences: {
					enabled: true,
					readOnly: false,
			  },
			  analytics: {
					enabled: true,
					readOnly: false,

					// Delete specific cookies when the user opts-out of this category
					autoClear: {
						cookies: [
							{
								name: /^_ga/,   // regex: match all cookies starting with '_ga'
							},
							{
								name: '_gid',   // string: exact cookie name
							}
						]
					}
				},
				marketing: {
					enabled: true,
					readOnly: false,
				},
			},

			language: {
				default: 'en',

				translations: {
					 en: {
						consentModal: {
							title: 'Cookies',
							description: 'We use cookies to personalize content and ads, to analyze our traffic, and to improve our service.',
							acceptAllBtn: 'Accept All',
							acceptNecessaryBtn: 'Reject All',
							showPreferencesBtn: 'Manage Preferences'
						},
						preferencesModal: {
							title: 'Your Cookie Preferences',
							acceptAllBtn: 'Accept All',
							acceptNecessaryBtn: 'Reject All',
							savePreferencesBtn: 'Save Preference',
							closeIconLabel: 'Close',
							sections: [
								{
									description: 'Cookies are text files that are placed on your device by websites that you visit or by clicking on a link to a site within an email. They are used for website functionality as well as to provide information to website owners.'
								},
								{
									title: 'Necessary Cookies',
									description: 'Cookies that the site cannot function properly without. This includes cookies for access to secure areas and CSRF security. Please note that our site\'s default cookies do not collect any personal or sensitive information. Our site\'s default cookies do not collect IP addresses. The information they store is not sent to any 3rd parties.',
									//this field will generate a toggle linked to the 'necessary' category
									linkedCategory: 'necessary'
								},
								{
									title: 'Analytics',
									description: 'Analytics cookies help us understand how visitors interact with our website by collecting and reporting information anonymously. ',
									linkedCategory: 'analytics'
								},
								{
									title: 'Marketing',
									description: 'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers.',
									linkedCategory: 'marketing'
								}
							]
						}
					}
				}
			},

			// UI Customization
			guiOptions: {
				consentModal: {
					layout: 'bar inline',
					position: 'bottom'
				}
			}
		});

		function updateGtagConsent() {
			if (typeof gtag != "undefined") {
				gtag('consent', 'update', {
					'ad_storage': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
					'ad_user_data': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
					'ad_personalization': CookieConsent.acceptedCategory('marketing') ? 'granted' : 'denied',
					'analytics_storage': CookieConsent.acceptedCategory('analytics') ? 'granted' : 'denied',
					'functionality_storage': CookieConsent.acceptedCategory('preferences') ? 'granted' : 'denied',
					'personalization_storage': CookieConsent.acceptedCategory('preferences') ? 'granted' : 'denied',
				});
			}
		}
	}
}

export default CookieConsentInit;
